import styled from 'styled-components';
import { getGridSpans, getSpace, mq, getTransition, getColor } from '../../../stylesheets/tools';

const StyledAnchorLinks = styled.div`
  margin: 9rem 0 ${getSpace('xxl')};

  .anchorLinks__list {
    border-bottom: 2px solid #000;
    ${getGridSpans('width', { s: 12, m: 7 })}
    ${getGridSpans('padding-left', { s: 0, m: [1, 'spread'] })}
  }

  .anchorLinks__vertical-slice {
    padding-bottom: ${getSpace('m')};
  }

  .anchorLinks__link {
    width: 100%;
    appearance: none;
    border: 0;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 10px 0;
    color: ${getColor('black')};

    svg {
      flex-shrink: 0;
      margin-right: 10px;
      top: 2px;
      position: relative;
      ${getTransition('anchorLinks')}

      ${mq('m')} {
        margin-right: 20px;
      }
    }

    & + span {
      margin-top: ${getSpace('s')};
    }

    ${mq('m')} {
      align-items: flex-end;
    }

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    &:hover svg,
    &:focus svg {
      transform: translateY(3px);

      path {
        fill: ${props => props.theme.siteTheme.borderColor};
      }
    }
  }

  .anchorLinks__headline {
    display: inline-block;
    margin-bottom: 0;
    text-align: left;
  }

  ${mq('m')} {
    .anchorLinks__list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: ${getSpace('s')};
      width: 100%;
    }
  }
`;

export default StyledAnchorLinks;
